import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const MessageDialog = ({ open, onClose, title, message, actionLabel = 'Cerrar', onAction }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <div>
          {message.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onAction || onClose} color="primary">
          {actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialog;